import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';
export var PhoneNumberUtils = {
    isValidPhoneNumber: function (phone, countryCode) { return isValidPhoneNumber(phone, countryCode); },
    parsePhoneNumber: function (phone) { return parsePhoneNumberFromString(phone); }
};
